module.exports = __webpack_public_path__ + "img/c02_buildingstartechtownwatch_Normal_ua.f5396b52.webp";